/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "PostAuthAPI",
            "endpoint": "https://5e5n6uku1j.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:8817f48e-9e7b-46a4-91ea-42f4b35a55b3",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_vRDVX9u35",
    "aws_user_pools_web_client_id": "3883m0kpos9ad6h6h5kp6ntpdt",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "dev.biomechnet.org-prod",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "http://dev.biomechnet.org-prod.s3-website-us-west-2.amazonaws.com",
    "aws_user_files_s3_bucket": "biomechanics-uploads83039-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
